// extracted by mini-css-extract-plugin
export var articles = "page-listing-module--articles--nltiw";
export var description = "page-listing-module--description--wVRaP";
export var image = "page-listing-module--image--Y8QSi";
export var item = "page-listing-module--item--czn0y";
export var link = "page-listing-module--link--PrAJv";
export var list = "page-listing-module--list--crUOO";
export var pageListingWrapper = "page-listing-module--pageListingWrapper--M1NXi";